import { render, staticRenderFns } from "./employeeInfo.vue?vue&type=template&id=63aa93a8&"
import script from "./employeeInfo.vue?vue&type=script&lang=js&"
export * from "./employeeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports